import React from 'react';
import { Square, Row } from '@grubhubprod/gh-cookbook-react';

export const DataTableHeader: React.FC = ({ children }) => (
  <Square
    as="header"
    inset="md"
    bg="tintedBackground"
    borderBottom="1px solid"
    borderColor="lightLine"
  >
    <Row gutter={12}>{children}</Row>
  </Square>
);
